export default __webpack_public_path__ + "static/media/retirar-dinero.62c21082.png";